<div class="dd-app-header" *ngIf="sharedData && sharedData?.showHeader === true">
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
    <div *ngIf="sharedData.dealerDetails && !sharedData.dealerDetails?.isLexus" class="toyota-logo">
      <img src="../../../../assets/icons/Toyota_logo_no-text.svg" height="44px" width="44px" fxShow.xs="true" fxShow="false" />
      <img src="../../../../assets/icons/Toyota-Logo-Header.svg" height="auto" fxShow.gt-xs="true" fxShow="false" />
    </div>
    <div *ngIf="sharedData.dealerDetails && sharedData.dealerDetails?.isLexus" class="toyota-logo">
      <img src="../../../../assets/icons/Lexus-Logo-Header.svg" height="auto" fxShow.gt-xs="true" fxShow="false" />
    </div>
    <div fxLayout="column" fxLayoutAlign="center end" class="dd-header-right">
      <div [innerHTML]="sharedData?.dealerDetails?.dealerName" class="dd-dealer-name"></div>
      <div fxLayout="row">
        <dd-phone-number [phoneNumber]="sharedData?.dealerDetails?.phone" (click)="omTag.fireOmnitureTag('vheader_km-dealer-contact-call', {url:'', href: '', text:sharedData?.dealerDetails?.phone, trigger:'km-link'} , sharedData);"></dd-phone-number>
      </div>
    </div>
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
